var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPerpSpotIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 15,
  x: 1,
  y: 1,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2,
  rx: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M11.375 5.462h-6.75M9.625 8.923h-5M7 12.385H4.625"
})));
export default SvgPerpSpotIcon;